import { Helmet } from "react-helmet-async";

// Injects one or more JSON-LD blocks without touching the page <title>.
export default function JsonLd({ data }) {
  const items = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {items.map((d, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(d)}</script>
      ))}
    </Helmet>
  );
}
